import "bootstrap/dist/css/bootstrap-theme.css";
import "bootstrap/dist/css/bootstrap.css";
import "normalize.css/normalize.css";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./css/index.css";
import registerServiceWorker from "./registerServiceWorker";
import ApplicationService from "./services/applicationService";
import FirebaseAuthService from "./services/auth/firebaseAuthService";
import { IAuthService } from "./services/auth/interfaces";
import { IApplicationService } from "./services/interfaces";
import { IProjectService } from "./services/project/interfaces";
import ProjectService from "./services/project/projectService";

const authService: IAuthService = new FirebaseAuthService();
const projectService: IProjectService = new ProjectService();
const appService: IApplicationService = new ApplicationService(authService, projectService);

ReactDOM.render(<App appService={appService} />, document.getElementById("root") as HTMLElement);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx